module.exports = __webpack_public_path__ + "static/img/ISSGS.d718ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISSGS.jpg
// module id = B6MS
// module chunks = 1